// core/http/http-context.tokens.ts
import { HttpContextToken } from '@angular/common/http';

export const SKIP_UNAUTHORIZED_HANDLING =
  new HttpContextToken<boolean>(() => false);